import AxiosFactory from "@/repositories/AxiosFactory";

const resource = "/admin/billing";

export default {
  store(data) {
    return AxiosFactory.post(resource, data);
  }
};
